import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-600" aria-label="面包屑导航">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          {index > 0 && (
            <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-400">
              <i className="ri-arrow-right-s-line text-sm" />
            </span>
          )}
          {item.to ? (
            <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}